import React from "react";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { geocodeByPlaceId } from "react-google-places-autocomplete";

interface LocationValue {
  label: any;
  value: any;
}

interface LocationInputProps {
  value?: LocationValue;
  onChange?: (value: LocationValue) => void;
  placeholder?: string;
}

const LocationInput: React.FC<LocationInputProps> = ({
  value = undefined,
  placeholder,
  onChange,
}) => {
  return (
    <div className="datetime-item">
      <img src="/images/location.png" alt="" />
      <GooglePlacesAutocomplete
        selectProps={{
          value,
          onChange: (place: any) => {
            if (place?.value) {
              geocodeByPlaceId(place.value.place_id)
                .then((results) => {
                  if (results[0].geometry) {
                    const attributes = {
                      address: "",
                      zip: "",
                      stAddressOne: "",
                      stAddressTwo: "",
                      city: "",
                      state: "",
                      country: "",
                    };
                    for (const address_component of results[0]
                      .address_components) {
                      if (address_component.types.includes("postal_code")) {
                        attributes.zip = address_component.short_name || "";
                      } else if (
                        address_component.types.includes("locality") ||
                        address_component.types.includes("sublocality_level_1")
                      ) {
                        attributes.city = address_component.short_name;
                      } else if (
                        address_component.types.includes(
                          "administrative_area_level_1"
                        )
                      ) {
                        attributes.state = address_component.short_name;
                      } else if (address_component.types.includes("country")) {
                        attributes.country = address_component.long_name;
                      }
                    }
                    attributes.address = results[0].formatted_address;
                    let location = { ...place, type: 'location' };
                    location.value = {
                      ...location.value,
                      coordinates: {
                        lat: results[0].geometry.location.lat(),
                        long: results[0].geometry.location.lng(),
                      },
                      attributes
                    };
                    onChange(location);
                  }
                })
                .catch((error) => console.error(error));
            }
          },
          isClearable: false,
          placeholder: placeholder,
          menuPortalTarget: document.body,
          menuPosition: 'fixed',
          styles: {
            input: (provided: any) => ({
              ...provided,
              fontFamily: "Nunito-Regular",
            }),
            control: () => ({
              backgroundColor: "transparent",
              display: "flex",
            }),
            container: (provided, state) => ({
              ...provided,
              width: "100%",
              background: "transparent",
            }),
            // option: (provided, state) => ({
            //   ...provided,
            //   background: "red",
            // }),
            placeholder: (provided, state) => ({
              ...provided,
              color: "#000",
              fontSize: 16,
              padding: 8,
            }),
            singleValue: (provided, state) => ({
              ...provided,
              color: "#000",
              fontSize: 16,
              padding: 8,
            }),
            menu: (provided, state) => ({
              ...provided,
              zIndex: 99999999,
            }),
            menuPortal: (provided, state) => ({
              ...provided,
              zIndex: 99999999,
            }),
          },
        }}
        apiKey={"AIzaSyDNIyoSDV1wnJVW8wdHkiNG-eZ2bMcq0iY"}
      />
    </div>
  );
};

export default LocationInput;
